import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function Pool({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 16 16" fill="currentColor">
      <path d="M16,8c0-.19,0-.38,0-.57A7.43,7.43,0,0,0,8.57,0h0L8,0V8Z" />
      <path d="M6.86,9.14v-8A7.43,7.43,0,0,0,0,8.57C0,8.76,0,9,0,9.14A7.42,7.42,0,0,0,6.86,16l.57,0a7.43,7.43,0,0,0,7.4-6.86Z" />
    </SvgIcon>
  )
}
